<div class="wp-rb-main-layout opt-regular-booking" id="layOutTop">
    <opt-wp-seasons-carousel (emitChangeSeason)="ReciveSeasonChanges($event)"></opt-wp-seasons-carousel>

    <br />
    <opt-wp-add-teams (bookingSaveResult)="navigateNextStepper($event)"></opt-wp-add-teams>
</div>